import React from 'react';
import "../css/components/checkBox.css"

interface CheckBoxProps {
    children: React.ReactNode;
    checked?: boolean;
    onCheck: (checked: boolean) => void;
    id?: string;
}

const CheckBox: React.FC<CheckBoxProps> = ({children, checked = false, onCheck, id}) => (
    <div className="ss-checkbox-container">
        <div>
            <input type="checkbox"
                   className="ss-checkbox-container-checkbox"
                   checked={checked}
                   onChange={(event) => onCheck(event.target.checked)}
                   id={id}
            />
        </div>
        <div>
            {children}
        </div>
    </div>
)

export default CheckBox;
